import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { ViewBlacklistRequest } from '../api/blacklist/viewblacklist/viewblacklistrequest';
import { ViewBlacklistResponse, ViewBlacklistResponseDtoImpl } from '../api/blacklist/viewblacklist/viewblacklistresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { ViewBlacklistBuilder } from '../dto/viewblacklist/viewblacklistbuilder';
import { ViewBlacklistDtoImpl } from '../dto/viewblacklist/viewblacklistdto';
import { Strings } from '../../utils/resources/strings';

export class ViewBlacklistAPIProcessorImpl extends SixdeeCRBTAPIProcessor<ViewBlacklistRequest, ViewBlacklistResponse>
{
    execute(request: ViewBlacklistRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new ViewBlacklistResponseDtoImpl(APIFeatures.VIEW_BLACKLIST, "View Blacklist Success");

               let viewBlacklistDto = new ViewBlacklistDtoImpl();
               viewBlacklistDto.setMemberDetails(new ViewBlacklistBuilder(responseMapper.getResponseMap()).buildAll());

                response.setViewBlacklist(viewBlacklistDto);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new ViewBlacklistResponseDtoImpl(APIFeatures.VIEW_BLACKLIST, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new ViewBlacklistResponseDtoImpl(APIFeatures.VIEW_BLACKLIST, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new ViewBlacklistResponseDtoImpl(APIFeatures.VIEW_BLACKLIST, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
 
            this.getAPIFailure(new ViewBlacklistResponseDtoImpl(APIFeatures.VIEW_BLACKLIST, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/viewblacklistapiprocessor.tsx